import { Icon } from "@/components/Icon/Icon";

export function RowKebab() {
  return (
    <button
      type="button"
      className="sl-kebab"
      onClick={(e) => e.stopPropagation()}
      style={{
        width: 26, height: 26, borderRadius: 6, display: "inline-flex",
        alignItems: "center", justifyContent: "center", color: "var(--ink-4)",
        background: "transparent", border: "1px solid transparent",
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = "var(--bg-sunk)"; e.currentTarget.style.borderColor = "var(--line)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.borderColor = "transparent"; }}
    >
      <Icon name="dots" size={15} />
    </button>
  );
}
